export class QBIsEntityAuthorizedRequest{
    public customerId!:number;
    public clientIds!:number[];
}